import getDisplayName from 'data/services/profile/getDisplayName';
import { ItemUser } from 'data/firestore/globals';

const getDisplayNameForParticipant = (
    participant: ItemUser[],
    maxVisible: number,
) => {
    if (participant.length === 1) return getDisplayName(participant[0]);
    return participant.slice(0, maxVisible).map((user) => getDisplayName(user).split(' ').at(0)).join(', ');
};

export default getDisplayNameForParticipant;
